import { IconLogo } from 'src/components/Svg/Images';
import { cn } from 'src/lib/utils';

import { useAppCard } from '../model/context';

const Watermark = () => {
  const { data } = useAppCard();
  const { brandLogo } = data;

  const variant = !data.claimed ? 'unclaimed' : brandLogo ? 'branded' : 'generic';

  return (
    <div
      data-testid="app-card-watermark"
      data-variant={variant}
      aria-hidden="true"
      className="absolute size-66 -right-[85.5px] -top-[85.5px] z-1 pointer-events-none flex items-center justify-end rounded-full transition-transform duration-200 ease-linear group-hover:scale-110"
    >
      {variant === 'branded' && brandLogo ? (
        <img
          data-testid="brand-logo"
          src={brandLogo}
          alt={data.name ?? 'Untitled application'}
          className="size-full object-contain opacity-10 rounded-full"
        />
      ) : (
        <IconLogo className={cn('size-full', variant === 'unclaimed' ? 'opacity-[0.03]' : 'opacity-5')} />
      )}
    </div>
  );
};

export { Watermark };
